const GROUP_JOBTITLE_DATA = {
    GROUP_JOBTITLE_DATA_LOAD: "GROUP_JOBTITLE_DATA_LOAD",
    GROUP_JOBTITLE_DATA_SUCCESS: "GROUP_JOBTITLE_DATA_SUCCESS",
    GROUP_JOBTITLE_DATA_FAIL: "GROUP_JOBTITLE_DATA_FAIL",
  };
  
  const GROUP_JOBTITLE_GET_API = "/employee/v1/GroupByJobTitle";
  
  //Get 
  const GROUP_JOBTITLE_GET_DATA = {
    GROUP_JOBTITLE_GET_DATA_LOAD: "GROUP_JOBTITLE_GET_DATA_LOAD",
    GROUP_JOBTITLE_GET_DATA_SUCCESS: "GROUP_JOBTITLE_GET_DATA_SUCCESS",
    GROUP_JOBTITLE_GET_DATA_FAIL: "GROUP_JOBTITLE_GET_DATA_FAIL",
  };
  
  const GROUP_JOBTITLE_GET_DETAIL_API = "/employee/v1/GroupByJobTitle/";

  //Ticketing APIs

  //To Get group by Type admin for ticketing
  const GROUPBYTYPE_ADMIN_GET_DATA = {
    GROUPBYTYPE_ADMIN_GET_DATA_LOAD: "GROUPBYTYPE_ADMIN_GET_DATA_LOAD",
    GROUPBYTYPE_ADMIN_GET_DATA_SUCCESS: "GROUPBYTYPE_ADMIN_GET_DATA_SUCCESS",
    GROUPBYTYPE_ADMIN_GET_DATA_FAIL: "GROUPBYTYPE_ADMIN_GET_DATA_FAIL",
  };
  
  const GROUPBYTYPE_ADMIN_GET_DETAIL_API = "/employee/v1/getGroupByType/";
 
  //To Get group by Type admin for ticketing
  const GROUPBYTYPE_USER_GET_DATA = {
    GROUPBYTYPE_USER_GET_DATA_LOAD: "GROUPBYTYPE_USER_GET_DATA_LOAD",
    GROUPBYTYPE_USER_GET_DATA_SUCCESS: "GROUPBYTYPE_USER_GET_DATA_SUCCESS",
    GROUPBYTYPE_USER_GET_DATA_FAIL: "GROUPBYTYPE_USER_GET_DATA_FAIL",
  };
  
  const GROUPBYTYPE_USER_GET_DETAIL_API = "/employee/v1/getGroupByType/";

  //Get 
  const GROUPBY_ID_JOBTITLE_GET_DATA = {
    GROUPBY_ID_JOBTITLE_GET_DATA_LOAD: "GROUPBY_ID_JOBTITLE_GET_DATA_LOAD",
    GROUPBY_ID_JOBTITLE_GET_DATA_SUCCESS: "GROUPBY_ID_JOBTITLE_GET_DATA_SUCCESS",
    GROUPBY_ID_JOBTITLE_GET_DATA_FAIL: "GROUPBY_ID_JOBTITLE_GET_DATA_FAIL",
  };
  
  const GROUPBY_ID_JOBTITLE_GET_DETAIL_API = "/employee/v1/getEmpByGroup/";

  
  
  export {
    GROUP_JOBTITLE_DATA,
    GROUP_JOBTITLE_GET_API,
    GROUP_JOBTITLE_GET_DATA,
    GROUP_JOBTITLE_GET_DETAIL_API,
    // Ticketing APIs
    GROUPBYTYPE_ADMIN_GET_DATA,
    GROUPBYTYPE_ADMIN_GET_DETAIL_API, 
    GROUPBYTYPE_USER_GET_DATA,
    GROUPBYTYPE_USER_GET_DETAIL_API, 
    GROUPBY_ID_JOBTITLE_GET_DATA,
    GROUPBY_ID_JOBTITLE_GET_DETAIL_API,
  }; 
  